import { useCallback, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { ReportProps } from "../../../../types/types";
import { ValidationErrorSection } from "../../../kpi/setup/validation/ValidationErrorSection";
import { QueryEditor } from "./QueryEditor";
import { useAuth } from "../../../../providers/AuthProvider";
import { commonGet } from "../../../../services/reportService";
import { Option } from "../../../manageReport/type";
import { ArrayUtils } from "../../../../utils/arrayUtils";
import { Text } from "@mantine/core";
import "./ReportQueryFormPage.css";

export function ReportQueryFormPage(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  const QueryInfo = (props.currentReportComponent==="viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.queryInfoViewReport:props.queryInfo;
  props.reportInfo.implementation = QueryInfo.name;  
  const createOption = (label: string) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ""),
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<Option[]>([]);
  const [value, setValue] = useState<Option | null>({
    label: QueryInfo.name,
    value: QueryInfo.name,
  });

  useEffect(() => {
    if (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") {
      setValue({
        label: props.queryInfoViewReport.name,
        value: props.queryInfoViewReport.name
      })
    }
    else {
      setValue({
        label: props.queryInfo.name,
        value: props.queryInfo.name
      })
    }
  }, [props.currentReportComponent, props.diffrentQueryForViewReportFlag])

  // const [queryInfo, setQueryInfo] = useState<QueryInfo>({ name: "", query: "", language: "", implementation: "", type: "", description: "", enabled: true, params: {},UIParams:[]});

  const getQueries =useCallback( async (): Promise<void> => {
    let url = "/v1/query/queryNameList";
    let response = await commonGet(url, authContext);
    const defaultOptions: Option[] = response.features[0].map(function (
      value: string
    ) {
      return createOption(value);
    });
    setOptions(defaultOptions);
  },[]);

  const getQueryByName = async (newValue: Option | null): Promise<void> => {
    if (newValue?.label != null) {
      let url = "/v1/query/info/" + newValue!.label;
      let response = await commonGet(url, authContext);

      props.currentReportComponent==="viewReport"?props.setQueryInfoViewReport({
        id: response.id,
        name: response.name,
        query: response.query,
        language: "sql",
        description: "",
        enabled: true,
        implementation:
          "com.applicate.services.channelkart.querys.DynamicQueryExecutor",
        type: "Analytics",
        params: {},
        UIParams: [],
        owner: "",
        reviewer: "",
        reviewStatus: "PENDING",
      }):props.setQueryInfo({
        id: response.id,
        name: response.name,
        query: response.query,
        language: "sql",
        description: "",
        enabled: true,
        implementation:
          "com.applicate.services.channelkart.querys.DynamicQueryExecutor",
        type: "Analytics",
        params: {},
        UIParams: [],
        owner: "",
        reviewer: "",
        reviewStatus: "PENDING",
      });
    }
    setValue(newValue);
  };

  useEffect(() => {
    getQueries();
    props.setReportState((currentState) => ({
      ...currentState,
      validationErrors: currentState.validationErrors.filter(er => er.property !== 'noApiResponse')
    }))
  }, [getQueries]);
  const noApiResponse =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "noApiResponse")
      .map((error) => error.message)[0];

  const handleCreate = (inputValue: string) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      setOptions((prev) => [...prev]);
      setValue(newOption);
      //props.setIsQueryEditable(true) ;
      // QueryInfo.name=newOption.value
      props.currentReportComponent==="viewReport"?props.setQueryInfoViewReport({
        id: newOption.value,
        name: newOption.value,
        query: "",
        language: "sql",
        description: "",
        enabled: true,
        implementation:
          "com.applicate.services.channelkart.querys.DynamicQueryExecutor",
        type: "Analytics",
        params: {},
        UIParams: [],
        owner: "",
        reviewer: "",
        reviewStatus: "PENDING",
      }):props.setQueryInfo({
        id: newOption.value,
        name: newOption.value,
        query: "",
        language: "sql",
        description: "",
        enabled: true,
        implementation:
          "com.applicate.services.channelkart.querys.DynamicQueryExecutor",
        type: "Analytics",
        params: {},
        UIParams: [],
        owner: "",
        reviewer: "",
        reviewStatus: "PENDING",
      });
      //    setQueryInfo(queryInfo);
    }, 1000);
  };

  return (
    <div className="full-width-height wizard-content-card ">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="full-width">
          <div className="input-div select" id="query-editor-component">
            <CreatableSelect
              isClearable
              isDisabled={
                props.reportInfo.viewEditStatus === "VIEW" ? true : false
              }
              isLoading={isLoading}
              onChange={(newValue) => getQueryByName(newValue)}
              onCreateOption={handleCreate}
              options={options}
              value={value}
              className={"form-select"}
              placeholder="Search Query"
              styles={{
                control: (provided) => ({
                  ...provided,
                  width: '85%', 
                  borderRadius:"10px"
                }),
                option: (provided, state) => ({
                  ...provided,
                  height: 50, // Set height in px
                  opacity: state.isDisabled ? 0.5 : 1, // Opacity for disabled vs normal
                  padding: '10px 12px', 
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999, 
                  width:"85%"// Ensure dropdown appears on top if needed
                }),
              }}
            />
            <QueryEditor {...props} />
          </div>
        </div>
      </div>
      {noApiResponse && (
        <Text style={{textAlign: 'center'}} color="red">{noApiResponse}</Text>
      )}
      <div className="sqlQueryConfigurationStep-error">
        <ValidationErrorSection
          errors={props.validationErrors.filter(
            (validationErrorObject) =>
              validationErrorObject.property === "Query"
          )}
        />
      </div>

      <div className="sqlQueryConfigurationStep-error">
        <ValidationErrorSection
          errors={props.validationErrors.filter(
            (validationErrorObject) =>
              validationErrorObject.property === "Query"
          )}
        />
      </div>

      <div className="sqlQueryConfigurationStep-container">
        <div id="queryCard-Container"></div>
      </div>
    </div>
  );
}
